import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { CartProvider } from "./context/CartContext";
import { ProductsProvider } from "./context/ProductsContext";
import { ContentProvider } from "./context/ContentContext";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AnnouncementBar from "./components/AnnouncementBar";
import WhatsAppFloat from "./components/WhatsAppFloat";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import WholesalePage from "./pages/WholesalePage";
import NotFoundPage from "./pages/NotFoundPage";
import EditorPage from "./pages/EditorPage";

const Shell = ({ children }) => {
  const loc = useLocation();
  const isEditor = loc.pathname.startsWith("/editor");
  return (
    <>
      {!isEditor && <AnnouncementBar />}
      {!isEditor && <Header />}
      {children}
      {!isEditor && <Footer />}
      {!isEditor && <WhatsAppFloat />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <ProductsProvider>
        <ContentProvider>
          <CartProvider>
            <BrowserRouter>
              <Shell>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/shop" element={<ShopPage />} />
                  <Route path="/product/:id" element={<ProductPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/wholesale" element={<WholesalePage />} />
                  <Route path="/editor" element={<EditorPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </Shell>
              <Toaster />
            </BrowserRouter>
          </CartProvider>
        </ContentProvider>
      </ProductsProvider>
    </div>
  );
}

export default App;
